import { memo, ImgHTMLAttributes } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  removeLazyLoad?: boolean
}

const Component = ({ removeLazyLoad = false, ...rest }: Props) => {
  return (
    <LazyLoadImage
      {...rest}
      width={rest?.width || '100%'}
      height={rest?.height || '100%'}
      title={rest.title || rest.alt}
      loading={rest.loading || 'lazy'}
      visibleByDefault={removeLazyLoad}
    />
  )
}

export const ImageOptimization = memo(Component)
